import type {RootState} from '@local/redux/store';
import type {SnackbarState} from '@local/redux/state/snackbar';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {useDispatch, useSelector} from 'react-redux';
import type {SnackbarCloseReason} from '@mui/material/Snackbar/Snackbar';
import type {SyntheticEvent} from 'react';
import {useEffect, useState} from 'react';
import {snackbarActions} from '@local/redux/slice/snackbar';

export const GlobalSnackbar = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector<RootState, SnackbarState>(({snackbar}) => snackbar);

  const handleClose = (event: SyntheticEvent<any> | Event, reason?: SnackbarCloseReason) => {
    if (!reason || reason === 'timeout') {
      dispatch(snackbarActions.close());
    }
  };

  // 連続で状態が変わったときに違いが分からんので連続したら一瞬閉じるようにする
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (snackbar.open) {
      setKey(Date.now());
    }
  }, [snackbar]);

  return (
    <Snackbar
      key={key}
      open={snackbar.open}
      autoHideDuration={snackbar.duration ?? 7000}
      onClose={handleClose}
      anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}
    >
      <Alert onClose={handleClose} severity={snackbar.severity} sx={{whiteSpace: 'pre-wrap'}}>
        {snackbar.message ?? ''}
      </Alert>
    </Snackbar>
  );
};
